import { RefObject } from 'react';
import media from '@activebrands/core-web/config/media';
import { inBrowser } from '@activebrands/core-web/utils/constants';
import { matchesMedia } from '@activebrands/core-web/utils/responsive';

const scrollToTopOfRef = (ref: RefObject<HTMLElement>, headerHeight: number | undefined): void => {
    const isDesktop = matchesMedia(media.min['desktop.sm']);

    if (inBrowser && ref?.current) {
        let offset = 0;
        if (headerHeight && isDesktop) {
            offset = headerHeight;
        }

        const scrollTarget = ref.current.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
            top: scrollTarget,
            behavior: 'smooth',
        });
    }
};

export default scrollToTopOfRef;
